import { projectFileOperationResponseSchema, type ProjectFileOperationRequest, type ProjectFileOperationResponse } from "@maestros/contracts";
import { api } from "../../api/client.ts";

export async function pollProjectFileOperation(projectId: string, id: string, signal?: AbortSignal): Promise<ProjectFileOperationResponse> {
  return projectFileOperationResponseSchema.parse(await api(`/projects/${projectId}/files/${id}`, signal ? { signal } : {}));
}
export async function requestProjectFiles(projectId: string, body: ProjectFileOperationRequest, signal?: AbortSignal): Promise<ProjectFileOperationResponse> {
  let response = projectFileOperationResponseSchema.parse(await api(`/projects/${projectId}/files`, { method: "POST", body, idempotencyKey: crypto.randomUUID(), ...(signal ? { signal } : {}) }));
  for (let count = 0; response.state === "pending" && count < 60; count++) {
    await new Promise<void>((resolve, reject) => {
      if (signal?.aborted) { reject(new DOMException("Aborted", "AbortError")); return; }
      const abort = () => { clearTimeout(timer); reject(new DOMException("Aborted", "AbortError")); };
      const timer = setTimeout(() => { signal?.removeEventListener("abort", abort); resolve(); }, 500);
      signal?.addEventListener("abort", abort, { once: true });
    });
    response = await pollProjectFileOperation(projectId, response.id, signal);
  }
  return response;
}
